module.exports = __webpack_public_path__ + "static/homeBG-8c6ada40762093a3958f49a91eac6af7.jpg";